"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWorkflowActionSection = void 0;
const DefaultSubsections = require("./helpers/defaultSubsections");
const Localization_utils = require("../../localization-utils");
const flattenAeSchema_1 = require("./helpers/flattenAeSchema");
const sortByOrder_1 = require("./helpers/sortByOrder");
const debug_1 = require("debug");
const warnLog = (0, debug_1.default)('reporting:warning');
/**
 * Builds a section that will display a workflow-action
 * @param {Object} workflowSchema The MongoDB object containing the schema for this workflow.
 * @param {string} action The key that the workflow uses to identify this type of action
 * @param {LanguageString} language The language (usually "en")
 * @param {Object} [options] The options object

 * @returns {SheetSchema | null} Returns null when an action with no renderable data is passed in.
 */
function buildWorkflowActionSection(section, workflowSchema) {
    var _a, _b;
    const { options, action } = section;
    const localizedAction = Localization_utils.localizeActionType(workflowSchema, action);
    const language = (options === null || options === void 0 ? void 0 : options.language) || 'en';
    let subsections = [];
    const properties = ((_b = (_a = workflowSchema === null || workflowSchema === void 0 ? void 0 : workflowSchema.schema) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b[action]) || {};
    Object.keys(properties).forEach((propertyKey) => {
        var _a;
        const propertyColumns = (0, flattenAeSchema_1.flattenAeSchema)(((_a = workflowSchema === null || workflowSchema === void 0 ? void 0 : workflowSchema.schema.actions) === null || _a === void 0 ? void 0 : _a[action]) || {}, [propertyKey], options);
        subsections = subsections.concat(propertyColumns);
    });
    if (options === null || options === void 0 ? void 0 : options.sortAlphabetically) {
        subsections.sort((a, b) => a.subtitle.localeCompare(b.subtitle, language, { numeric: true }));
    }
    else {
        subsections.sort((a, b) => (0, sortByOrder_1.sortByOrder)(a, b, properties));
    }
    if (!subsections.length && !(options === null || options === void 0 ? void 0 : options.showIfEmpty)) {
        warnLog('generated empty section');
        return null;
    }
    return {
        type: 'action',
        title: localizedAction,
        description: section.description || `Workflow Action Section (${localizedAction})`,
        action,
        workflow: workflowSchema._id.toString(),
        subsections: [
            DefaultSubsections.patientID(),
            ...subsections,
            DefaultSubsections.created_at(),
            DefaultSubsections.ongoingWorkflowColumn(),
        ],
    };
}
exports.buildWorkflowActionSection = buildWorkflowActionSection;
//# sourceMappingURL=workflowActionSection.js.map